import { useForm, useLatestEntity } from '@domain-group/react-hooks'
import type { UseFormOptions } from '@domain-group/react-hooks'

import useDispatch from '@hooks/useDispatch'
import useSelector from '@hooks/useSelector'

import * as autoOrderQueueActions from '@redux/modules/autoOrderQueue'

import defaultFormState, { requiredFields } from '@models/autoOrderQueue'

import type { AutoOrderQueueModel } from '@models/types'
import type { AppDispatch } from '@redux/store'

type ResolveUnhealthyAutoOrderQueuesParams = {
  autoOrderQueueIds: number[],
  dispatch: AppDispatch,
}

const resolveUnhealthyAutoOrderQueues = (params: ResolveUnhealthyAutoOrderQueuesParams) => {
  const { autoOrderQueueIds, dispatch } = params
  const { resolveUnhealthyAutoOrderQueues: resolveFn } = autoOrderQueueActions

  return dispatch(resolveFn(autoOrderQueueIds))
}

export const generateUrls = () => {
  return {
    autoOrderQueuesIndexUrl: '#/autoOrderQueues',
  }
}

type CustomFormOptions = {
  customRequiredFields?: UseFormOptions['requiredFields'],
}

export function useAutoOrderQueueForm(
  autoOrderQueue: Partial<AutoOrderQueueModel>,
  options: UseFormOptions & CustomFormOptions = {},
) {
  const { customRequiredFields = [], validateOn } = options || {}

  const autoOrderQueueForm = useForm(
    defaultFormState,
    { entity: autoOrderQueue, requiredFields: [...requiredFields, ...customRequiredFields], validateOn },
    [autoOrderQueue.id, autoOrderQueue.cacheKey],
  )

  return {
    ...autoOrderQueueForm,
  }
}

function useAutoOrderQueue(initEntity: Partial<AutoOrderQueueModel> = {}) {
  const { entity: autoOrderQueue }: { entity: AutoOrderQueueModel } = useLatestEntity(initEntity, 'autoOrderQueues')

  const dispatch = useDispatch()

  const {
    creating,
    loading,
  } = useSelector(reduxState => reduxState.autoOrderQueues)

  return {
    callbacks: {
      resolveUnhealthyAutoOrderQueues: (autoOrderQueueIds: number[]) => resolveUnhealthyAutoOrderQueues({ autoOrderQueueIds, dispatch }),
    },
    autoOrderQueue,
    creating,
    loading,
  }
}

export default useAutoOrderQueue
